import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export function KpiTile({
  label,
  value,
  unit,
  delta,
  hint,
  dataTestid,
  accent = "rgb(169,130,28)",
}) {
  const deltaUp = typeof delta === "number" && delta >= 0;
  return (
    <div
      data-testid={dataTestid}
      className="pj-card pj-card-hover transition-colors p-5 pl-6 flex flex-col justify-between relative overflow-hidden"
      style={{ minHeight: 120 }}
    >
      <div className="flex items-start justify-between gap-2">
        <span className="pj-label min-w-0 truncate" title={typeof label === "string" ? label : undefined}>
          {label}
        </span>
        {typeof delta === "number" && (
          <span
            className="mono inline-flex items-center gap-0.5 text-[10px] shrink-0"
            style={{ color: deltaUp ? "rgb(32,138,78)" : "rgb(196,52,44)" }}
          >
            {deltaUp ? <ArrowUpRight size={10} /> : <ArrowDownRight size={10} />}
            {Math.abs(delta).toFixed(1)}%
          </span>
        )}
      </div>
      <div className="flex items-baseline gap-2 mt-3 min-w-0">
        <span className="pj-value-xl min-w-0 truncate" title={value != null ? String(value) : undefined}>
          {value}
        </span>
        {unit && (
          <span
            className="mono shrink-0"
            style={{
              color: "rgb(var(--dim))",
              fontSize: 12,
              letterSpacing: "-0.02em",
            }}
          >
            {unit}
          </span>
        )}
      </div>
      {hint && (
        <div
          className="mono mt-2 truncate"
          title={typeof hint === "string" ? hint : undefined}
          style={{
            color: "rgb(var(--dim))",
            fontSize: 10,
            letterSpacing: "0.05em",
          }}
        >
          {hint}
        </div>
      )}
      <div
        className="absolute"
        aria-hidden
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          width: 2,
          height: 28,
          background: accent,
        }}
      />
    </div>
  );
}

export default KpiTile;
